'use client'

import React, { FC, ReactElement } from 'react'
import classNames from 'classnames'
import Link from 'next/link'

import InscriptionContent from '@/components/inscription-content'
import RarityPills from '@/components/rarity-pills-blur'

import { Inscription } from '@/utils/types/inscription'
import formatHiddenChars from '@/utils/format-hidden-chars'
import useInscriptionModal from '@/utils/hooks/useInscriptionModal'

import styles from './style.module.css'

const InscriptionCard: FC<{
	inscription: Inscription
	footer?: React.ReactNode
	subtitle?: string
}> = (props): ReactElement => {
	const { subtitle } = props
	const { id, num, content_type, collection: _collection, meta } = props.inscription
	const [_openWarning, _setOpenWarning] = React.useState(false)
	const openInscriptionModal = useInscriptionModal()

	const href = `/inscription/${id}`
	const name = formatHiddenChars(meta?.name as any)

	const handleClick = (evt: React.MouseEvent) => {
		if (evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.button === 1) return
		evt.preventDefault()
		openInscriptionModal({ id, inscription: props.inscription })
	}

	return (
		<Link
			href={href}
			onClick={handleClick}
			className={classNames(
				'border border-transparent rounded-3xl hover:border-[#B692F6] cursor-pointer overflow-hidden'
			)}
		>
			<div
				className={`${styles.mask} size-48 overflow-hidden rounded-3xl relative overflow-hidden`}
			>
				<div className="hover:scale-110 rounded-3xl transition duration-500 ease-in-out">
					<InscriptionContent
						className="size-48 roundex-3xl object-cover pointer-events-none inline"
						inscription={props.inscription}
					/>
				</div>
				<RarityPills className="absolute bottom-2 right-2" inscription={props?.inscription} />
			</div>
			<div className="flex flex-col p-3 w-48">
				<div className="flex flex-col">
					<p className="text-xs font-semibold">{name ? name : `Inscription #${num}`}</p>
					{!subtitle && (
						<p className="text-xs text-zinc-500 flex items-center gap-1">
							{name ? `Inscription #${num}` : content_type}
						</p>
					)}
					{subtitle && <p className="text-xs text-zinc-500 flex items-center gap-1">{subtitle}</p>}
				</div>
				{props.footer && <div className="mt-2">{props.footer}</div>}
			</div>
		</Link>
	)
}

export default InscriptionCard
